import React from 'react';
export default React.createContext({
  suppressSavedCars: false,
  suppressZipCode: false
});